// export const useAuthContext = () => {
//   const xAuthentication = useAppSelector((state) => state.authentication);
//   const isAuthenticated = xAuthentication.data?.isAuthenticated;
//   const isAdmin = xAuthentication.data?.isAdmin;
//   const user = xAuthentication.data?.user;

//   return {
//     isAuthenticated,
//     isAdmin,
//     user
//   };
// };


import { createContext, useContext, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import type { ChildrenType } from '../types/component-props'
import { UsersType } from '@/types/auth'
import { useCookies } from 'react-cookie';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { checkSession } from '../redux/features/core/authentication/authenticationSlice';

export type AuthContextType = {
  user: UsersType | undefined
  isAuthenticated: boolean
  saveSession: (session: UsersType) => void
  removeSession: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function useAuthContext() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider')
  }
  return context
}

const authSessionKey = '_UBOLD_AUTH_KEY_'


export function AuthProvider({ children }: ChildrenType) {

  
  const navigate = useNavigate()
  const xDispatch = useAppDispatch();



  // const [cookies, setCookie, removeCookie] = useCookies([authSessionKey]);

  // const getSession = (): AuthContextType['user'] => {
  //   const fetchedCookie = cookies[authSessionKey]
  //   if (!fetchedCookie) return
  //   else return fetchedCookie
  // }

  // const [user, setUser] = useState<UsersType | undefined>(getSession())

  // const saveSession = (user: UsersType) => {
  //   setCookie(authSessionKey, user)
  //   setUser(user)
  // }

  // const removeSession = () => {
  //   removeCookie(authSessionKey)
  //   setUser(undefined)
  //   navigate('/auth/login')
  // }

  const xAuthentication = useAppSelector((state) => state.authentication);
  const isAuthenticated = xAuthentication.data?.isAuthenticated;
  // const isAdmin = xAuthentication.data?.isAdmin;
  const user = xAuthentication.data?.user;

  useEffect(() => {
    xDispatch(checkSession())
  }, [xDispatch])

  useEffect(() => {
    if (isAuthenticated === false) {
      const timer = setTimeout(() => {
        navigate('/autenticazione')
      }, 2001)

      return () => clearTimeout(timer)
    }
  }, [isAuthenticated])

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: isAuthenticated,
        // isAdmin: isAdmin,
        saveSession: () => {},
        removeSession: () => {}
      }}>
      {children}
    </AuthContext.Provider>
  )
}




